import React from 'react';

import * as s from './PaginationLayout.css';

/**
 * Декоратор для пагинации
 */
export const PaginationLayout = ({ children }: { children: React.ReactNode }) => (
  <div className={s['wrapper']}>{children}</div>
);
